var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { useCallbackRef } from '../hooks';
import useHeight from './use-height';
import { animatedWrapperStyle } from './styles';
import Card from './card';
function Toast(_a) {
    var title = _a.title, description = _a.description, _b = _a.variant, variant = _b === void 0 ? 'info' : _b, disableAutoHide = _a.disableAutoHide, autoHideDuration = _a.autoHideDuration, onClose = _a.onClose;
    // A flag to trigger enter / exit animation
    var _c = __read(useState(true), 2), isVisible = _c[0], setIsVisible = _c[1];
    // For exit animation to work smoothly, height of animated wrapper is required
    var wrapperRef = useRef(null);
    var height = useHeight(wrapperRef);
    // Internal timer, a timeout after which the Toast is closed automatically
    var autoCloseTimer = useRef();
    var handleClose = useCallbackRef(function () {
        onClose();
    });
    // Close Toast after close button is clicked
    // First it triggers exit animation, after that it clears internal timer
    // To let exit animation finish before Toast unmount, close callback is triggered after a delay
    // Finally completely remove the Toast
    function forceClose() {
        if (isVisible) {
            setIsVisible(false);
            clearTimeout(Number(autoCloseTimer.current));
            setTimeout(function () {
                handleClose();
            }, 600);
        }
    }
    // Close toast after timeout, tracked internally
    useEffect(function () {
        if (isVisible && !disableAutoHide) {
            autoCloseTimer.current = setTimeout(function () {
                setIsVisible(false);
                setTimeout(function () {
                    handleClose();
                }, 600);
            }, autoHideDuration);
        }
        return function () {
            clearTimeout(Number(autoCloseTimer.current));
        };
    }, [isVisible, disableAutoHide, autoHideDuration, handleClose]);
    return (_jsx("li", __assign({ ref: wrapperRef, css: animatedWrapperStyle({ isVisible: isVisible, height: height }) }, { children: _jsx(Card, __assign({}, { title: title, variant: variant, description: description }, { onClose: forceClose })) })));
}
export default Toast;
